import { render, staticRenderFns } from "./LengthMeasurementField.vue?vue&type=template&id=610fd03c"
import script from "./LengthMeasurementField.vue?vue&type=script&lang=ts"
export * from "./LengthMeasurementField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports